'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle } from '@subframe/core';
import { CheckboxCard, Loader } from '@/shared/components/ui';
import { formatDateTimeFull } from '@/shared/formatters';
import type { ChaveDaSecao, PacoteListado, SecaoDosAutos } from '../../types/baixarProcesso.types';
import { chavesDisponiveis, DESCRICAO_DA_SECAO, listaEmPortugues, MOTIVO_DA_SECAO_INDISPONIVEL } from '../../utils/secoesDownload';
interface EtapaSelecaoSecoesProps {
  secoes: readonly SecaoDosAutos[];
  carregando: boolean;
  secoesMarcadas: readonly ChaveDaSecao[];
  /** Os dados mudaram antes da confirmação: alguma seção marcada deixou de existir. */
  aviso: string | null;
  pacoteJaGerado: PacoteListado | null;
  onAlternarSecao: (chave: ChaveDaSecao) => void;
  onAlternarTodas: () => void;
}
export function EtapaSelecaoSecoes(t0) {
  const $ = _c(65);
  const {
    secoes,
    carregando,
    secoesMarcadas,
    aviso,
    pacoteJaGerado,
    onAlternarSecao,
    onAlternarTodas
  } = t0;
  let t1;
  if ($[0] !== secoes || $[1] !== secoesMarcadas) {
    const disponiveis = chavesDisponiveis(secoes);
    t1 = disponiveis.length > 0 && disponiveis.every(chave => secoesMarcadas.includes(chave));
    $[0] = secoes;
    $[1] = secoesMarcadas;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const todasMarcadas = t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== aviso || $[4] !== carregando || $[5] !== onAlternarSecao || $[6] !== onAlternarTodas || $[7] !== secoes || $[8] !== secoesMarcadas || $[9] !== todasMarcadas) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t11;
      if ($[19] !== secoesMarcadas) {
        t11 = secao => secoesMarcadas.includes(secao.chave);
        $[19] = secoesMarcadas;
        $[20] = t11;
      } else {
        t11 = $[20];
      }
      const titulosMarcados = secoes.filter(t11).map(_temp);
      if (carregando) {
        let t12;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t12 = <div className="flex w-full flex-1 items-center justify-center gap-2.5 px-6 py-10 text-[13px] text-neutral-500" role="status"><Loader size="small" />Carregando as seções do processo…</div>;
          $[21] = t12;
        } else {
          t12 = $[21];
        }
        t10 = t12;
        break bb0;
      }
      t7 = "flex min-h-0 w-full flex-1 flex-col gap-[22px] overflow-y-auto px-6 pt-[18px] pb-6";
      if ($[22] !== aviso) {
        t8 = aviso ? <div className="border-warning-200 bg-warning-50 flex items-start gap-3 rounded-[12px] border border-solid px-[18px] py-3" role="alert"><FeatherAlertTriangle className="text-warning-700 mt-px h-[17px] w-[17px] flex-none" /><span className="text-warning-800 text-[12.5px] leading-[1.6]">{aviso}</span></div> : null;
        $[22] = aviso;
        $[23] = t8;
      } else {
        t8 = $[23];
      }
      let t12;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <span className="text-[12px] font-medium text-neutral-600" id="secoes-do-download">O que entra no documento</span>;
        $[24] = t12;
      } else {
        t12 = $[24];
      }
      const t13 = todasMarcadas ? "Limpar sele\xE7\xE3o" : "Selecionar tudo";
      let t14;
      if ($[25] !== onAlternarTodas || $[26] !== t13) {
        t14 = <div className="flex items-center justify-between gap-3">{t12}<button className="text-brand-600 text-[12px] font-medium hover:underline" onClick={onAlternarTodas} type="button">{t13}</button></div>;
        $[25] = onAlternarTodas;
        $[26] = t13;
        $[27] = t14;
      } else {
        t14 = $[27];
      }
      let t15;
      if ($[28] !== onAlternarSecao || $[29] !== secoes || $[30] !== secoesMarcadas) {
        let t16;
        if ($[32] !== onAlternarSecao || $[33] !== secoesMarcadas) {
          t16 = secao_1 => <CheckboxCard checked={secoesMarcadas.includes(secao_1.chave)} className="aria-[checked=true]:bg-default-background hover:aria-[checked=true]:bg-default-background w-full gap-3 rounded-none border-0 border-t border-solid border-neutral-100 bg-neutral-50 px-[14px] py-[10px] first:border-t-0 hover:bg-neutral-50 aria-[checked=true]:border-t aria-[checked=true]:border-solid aria-[checked=true]:border-neutral-100" disabled={!secao_1.disponivel} key={secao_1.chave} onCheckedChange={() => onAlternarSecao(secao_1.chave)}><span className="flex min-w-0 flex-1 flex-col gap-px"><span className={`text-[13.5px] font-medium ${secao_1.disponivel ? "text-default-font" : "text-neutral-400"}`}>{secao_1.titulo}</span><span className="text-[11.5px] text-neutral-500">{secao_1.disponivel ? DESCRICAO_DA_SECAO[secao_1.chave] : MOTIVO_DA_SECAO_INDISPONIVEL[secao_1.chave]}</span></span></CheckboxCard>;
          $[32] = onAlternarSecao;
          $[33] = secoesMarcadas;
          $[34] = t16;
        } else {
          t16 = $[34];
        }
        t15 = secoes.map(t16);
        $[28] = onAlternarSecao;
        $[29] = secoes;
        $[30] = secoesMarcadas;
        $[31] = t15;
      } else {
        t15 = $[31];
      }
      let t16;
      if ($[35] !== t15) {
        t16 = <div aria-labelledby="secoes-do-download" className="overflow-hidden rounded-[8px] border border-solid border-neutral-200" role="group">{t15}</div>;
        $[35] = t15;
        $[36] = t16;
      } else {
        t16 = $[36];
      }
      let t17;
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <p className="mt-px text-[11.5px] leading-[1.5] text-neutral-500">A capa e o índice dos autos entram sempre. Financeiro, custas e pendências não fazem parte deste download.</p>;
        $[37] = t17;
      } else {
        t17 = $[37];
      }
      if ($[38] !== t14 || $[39] !== t16) {
        t9 = <div className="flex flex-col gap-2">{t14}{t16}{t17}</div>;
        $[38] = t14;
        $[39] = t16;
        $[40] = t9;
      } else {
        t9 = $[40];
      }
      t5 = "bg-brand-50 flex flex-col gap-3 rounded-[12px] px-[18px] py-[14px]";
      const t18 = String(titulosMarcados.length);
      let t19;
      if ($[41] !== t18) {
        t19 = <TotalDoPainel rotulo={"Se\xE7\xF5es"} valor={t18} />;
        $[41] = t18;
        $[42] = t19;
      } else {
        t19 = $[42];
      }
      let t20;
      if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = <span className="bg-brand-100 h-[34px] w-px" />;
        $[43] = t20;
      } else {
        t20 = $[43];
      }
      const t21 = titulosMarcados.length > 0 ? "1" : "0";
      let t22;
      if ($[44] !== t21) {
        t22 = <TotalDoPainel rotulo="Arquivos" valor={t21} />;
        $[44] = t21;
        $[45] = t22;
      } else {
        t22 = $[45];
      }
      if ($[46] !== t19 || $[47] !== t22) {
        t6 = <div className="flex flex-wrap items-center gap-x-[22px] gap-y-3">{t19}{t20}{t22}</div>;
        $[46] = t19;
        $[47] = t22;
        $[48] = t6;
      } else {
        t6 = $[48];
      }
      t2 = "polite";
      t3 = "border-brand-100 border-t border-solid pt-[11px] text-[12px] leading-[1.5] text-neutral-600";
      t4 = titulosMarcados.length > 0 ? `Vai no documento: ${listaEmPortugues(titulosMarcados)}.` : "Nenhuma se\xE7\xE3o marcada.";
    }
    $[3] = aviso;
    $[4] = carregando;
    $[5] = onAlternarSecao;
    $[6] = onAlternarTodas;
    $[7] = secoes;
    $[8] = secoesMarcadas;
    $[9] = todasMarcadas;
    $[10] = t10;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[49] !== pacoteJaGerado) {
    t11 = pacoteJaGerado?.criadoEm ? ` Esta seleção já foi gerada em ${formatDateTimeFull(pacoteJaGerado.criadoEm)} e o processo não teve movimentação desde então — o download sai na hora.` : null;
    $[49] = pacoteJaGerado;
    $[50] = t11;
  } else {
    t11 = $[50];
  }
  let t12;
  if ($[51] !== t11 || $[52] !== t2 || $[53] !== t3 || $[54] !== t4) {
    t12 = <p aria-live={t2} className={t3}>{t4}{t11}</p>;
    $[51] = t11;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t12;
  } else {
    t12 = $[55];
  }
  let t13;
  if ($[56] !== t12 || $[57] !== t5 || $[58] !== t6) {
    t13 = <div className={t5}>{t6}{t12}</div>;
    $[56] = t12;
    $[57] = t5;
    $[58] = t6;
    $[59] = t13;
  } else {
    t13 = $[59];
  }
  let t14;
  if ($[60] !== t13 || $[61] !== t7 || $[62] !== t8 || $[63] !== t9) {
    t14 = <div className={t7}>{t8}{t9}{t13}</div>;
    $[60] = t13;
    $[61] = t7;
    $[62] = t8;
    $[63] = t9;
    $[64] = t14;
  } else {
    t14 = $[64];
  }
  return t14;
}
function _temp(secao_0) {
  return secao_0.titulo;
}
function TotalDoPainel(t0) {
  const $ = _c(7);
  const {
    rotulo,
    valor
  } = t0;
  let t1;
  if ($[0] !== rotulo) {
    t1 = <span className="text-[10px] font-semibold tracking-[0.05em] text-neutral-500 uppercase">{rotulo}</span>;
    $[0] = rotulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== valor) {
    t2 = <span className="text-brand-600 text-[18px] font-bold tabular-nums">{valor}</span>;
    $[2] = valor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-0.5">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}